// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9bae4d7a","696":"8813cbea"}[chunkId] + ".chunk.js";
};